import { format } from 'date-fns';
const baseURL = process.env.REACT_APP_POST_URL;

const columns = [
    {
        field: 'id',
        headerName: 'ID',
        width: 70,
        type: 'number',
        editable: false,
    },
    // {
    //     field: 'post_id',
    //     headerName: 'Post ID',
    //     width: 150,
    //     type: 'number',
    //     editable: true,
    // },
    {
        field: 'image',
        headerName: 'Image',
        width: 100,
        editable: true,
        renderCell: (params) => (
            params.value ? (
                <img
                    src={`${baseURL}/img/snapshot/${params.value}`}
                    alt="Post Image"
                    className="h-30 w-30 object-cover rounded-lg"
                />
            ) : (
                <span className="text-gray-500 italic">No Image</span>
            )
        ),
    },
    {
        field: 'project_name',
        headerName: 'Project Name',
        width: 300,
        editable: true,
    },
    {
        field: 'created_at',
        headerName: 'Created At',
        width: 200,
        type: 'string',
        editable: false,
        valueGetter: (value, row) => {
            return format(new Date(value), 'dd MMM yyyy, hh:mm a');
        }
    },
    {
        field: 'updated_at',
        headerName: 'Updated At',
        width: 200,
        type: 'string',
        editable: false,
        valueGetter: (value, row) => {
            return format(new Date(value), 'dd MMM yyyy, hh:mm a');
        }
    },
];

export default columns;
